// Libs
import axios from 'axios'

// Axios
import { serverAPI, searchAPI } from '../../index'
import _ from 'lodash'

// Action types
export const CHANGE_CASE = 'swap-case_change_case'
export const DEFAULT_CASE = 'swap-case_default_case'
export const CHANGE_SWAP_CASE_SEARCH = 'swap-case_change_search'
export const ERROR = 'swap-case_error'



export const changeCase = (cases) => {
  return {
    type: CHANGE_CASE,
    payload: cases
  }
}

export const defaultCase = () => {
  return { type: DEFAULT_CASE, payload: [] }
}

export const setError = (error = false) => {
  return { type: ERROR, payload: error }
}

export const changeSwapCaseSearch = (search) => {
  return {
    type: CHANGE_SWAP_CASE_SEARCH,
    payload: search
  }
}

export const fetchSearch = (search) => {
  return dispatch => {
    searchAPI.post('/', { value: search, size: 100, fields: [], from: 0 })
      .then(response => {
        dispatch(setError(false))
        if (response.data.hits.hits.length > 0) {
          dispatch(changeCase(response.data.hits.hits.map(e => e._source)))
        } else {
          dispatch(setError(true))
        }
      })
      .catch(e => {
        console.log(e)
        dispatch(setError(true))
      })
  }
}

export const fetchCases = (offset = 0, perPage = 15, callback) => {
  return dispatch => {
    serverAPI.post('/case', { offset, perPage })
      .then(response => {
        dispatch(setError(false))
        dispatch(changeCase(response.data.cases))
        callback && callback()
      })
      .catch(e => {
        console.log(e)
        callback && callback()
      })
  }
}
